import { hsaPdpWidgetPlacementSchema } from "@redotech/redo-conversion-settings-common/hsa-settings";
import * as z from "zod";

export const updateHsaSettings = {
  name: "updateHsaSettings" as const,
  input: z.object({
    pdpWidgetPlacement: hsaPdpWidgetPlacementSchema.optional(),
    /** Customer-facing checkout display name. Empty/absent clears it. */
    paymentMethodName: z.string().optional(),
  }),
  output: z.null(),
};
